import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.regexp.replace";
import _defineProperty from "D:\\projects\\xena\\node_modules\\@babel\\runtime-corejs2/helpers/defineProperty";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState, mapGetters } from 'vuex';
import { EventBus } from 'src/boot/eventbus';
export default {
  props: ['meazures'],
  components: {
    'registerEditAccount': require('components/RegisterEditAccount').default
  },
  data: function data() {
    return {
      langs: [{
        label: 'NL',
        value: 'nl-nl'
      }, {
        label: 'EN',
        value: 'en-us'
      }, {
        label: 'DE',
        value: 'de-de'
      }],
      // lang: this.$i18n.locale,
      lang: this.$i18n.locale,
      left: !this.$q.platform.is.mobile,
      // this.$q.platform.is.mobile ? false : !(this.isAuthenticated)
      left_prev: !this.$q.platform.is.mobile,
      miniState: false,
      userInfoOpen: false,
      showEditAccountDialog: false
    };
  },
  methods: {
    // handleMouseEnter () {
    //     alert('De muis is binnengekomen!')
    //     console.log('De muis is binnengekomen!')
    //     /* setTimeout(() => {
    //         hover.value = true
    //     }, proxy.$q.platform.is.ios ? 50 : 0) */
    //     // Voer hier andere logica uit
    // },
    handleTouchStart: function handleTouchStart(event) {
      alert('handleTouchstart event');
      console.log('Touch started!', event); // Your code here
    },
    getRandomInteger: function getRandomInteger(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min)) + min;
    },
    getFunds: function getFunds() {
      var result = '0';

      if (this.user.profile.amount) {
        result = this.user.profile.amount;
      }

      return result;
    },
    logout: function logout() {
      var _this = this;

      /* this.$meteor.logout()
      this.$q.notify({
          message: this.$t('messages.account_signed_out'),
          color: 'info'
      })
      this.$router.push({ name: 'welcome' }) */
      this.$meteor.logout();
      this.$q.loading.show({
        delay: 400 // ms

      });
      this.$q.notify({
        message: this.$t('messages.account_signed_out'),
        color: 'info'
      });
      setTimeout(function () {
        _this.$q.loading.hide();

        _this.$router.push({
          name: 'welcome'
        });
      }, 2000);
    },
    onInput: function onInput(value) {// console.log('CHANGE', value)
    },
    hasUnfinishedRegistration: function hasUnfinishedRegistration() {
      return !this.user.profile.owner && !this.user.profile.admin && this.measuresMine.length < 4 && this.user.profile.finishedRegister !== true;
    },
    hasExludingTags: function hasExludingTags() {
      var result = false;

      if (this.user.profile.tags) {
        result = this.user.profile.tags.some(function (r) {
          return ['kosterpolis', 'bornholmpolis'].includes(r);
        });
      }

      return result;
    },
    continueRegistration: function continueRegistration() {
      this.$router.push({
        path: "/survey/create-area/continue"
      });
    },
    onCLickMenu: function onCLickMenu() {
      this.left = !this.left; // if (this.$q.platform.is.mobile) {
      //     console.log('MINI', this.miniState)
      //     this.miniState = !this.miniState
      //     this.left = !this.left
      // } else {
      //     this.left = !this.left
      // }
    },
    showFlags: function showFlags() {
      var _this2 = this;

      // console.log('isModerator', this.isModerator)
      // console.log('land', this.land)
      // console.log('threads', this.land[0].threads)
      var bool = false;
      this.land.forEach(function (land) {
        return land.threads.forEach(function (thread) {
          return thread.comments.forEach(function (comment) {
            // console.log('comment', comment)
            // console.log('land.id', land.id)
            // console.log('comment.flagged', comment.flagged)
            // console.log('this.isModerator(land.id)', this.isModerator(land.id))
            if (comment.flagged && _this2.isModerator(land.id)) {
              bool = true;
            }
          });
        });
      }); // bool = this.land.filter(land =>
      //     land.threads.filter(thread =>
      //         thread.comments.filter(comment =>
      //             comment.flagged && this.isModerator(land.id)
      //
      //         )
      //
      //     )
      // )
      // console.log('bool', bool)

      return bool; // console.log('bool', bool.length)
    },
    showFlags2: function showFlags2() {
      var bool = false;
      this.landsOwner.forEach(function (land) {
        if (land.modrequests.length !== 0) {
          bool = true;
        }
      });
      return bool;
    },
    showFlags3: function showFlags3() {
      var _this3 = this;

      // console.log('isModerator', this.isModerator)
      // console.log('land', this.land)
      // console.log('threads', this.land[0].threads)
      var bool = false;
      this.land.forEach(function (land) {
        if (land.treasures) {
          land.treasures.forEach(function (treasure) {
            if (treasure.flagged && _this3.isModerator(land.id)) {
              bool = true;
            }
          });
        }
      }); // console.log('bool', bool)

      return bool; // console.log('bool', bool.length)
    }
  },
  computed: _objectSpread({}, mapState(['showToolbar', 'land', 'user']), {}, mapGetters(['isAuthenticated', 'user', 'isModerator', 'measuresMine', 'landsOwner', 'lands', 'hasInboxUnread']), {
    // theme switcher (src/themes) - labels only
    themeOptions: function themeOptions() {
      var _this4 = this;

      return this.$theme.list.map(function (name) {
        return {
          value: name,
          label: _this4.$t('theme.' + name.replace('-', '_'))
        };
      });
    }
  }),
  watch: {
    left: function left(val) {
      EventBus.$emit('drawerChanged', val); // this.showNoConnectionDialog = !val
    },
    lang: function lang(_lang) {
      this.$i18n.locale = _lang.value;

      try {
        this.$q.localStorage.set('locale', this.$i18n.locale);
      } catch (e) {
        console.log(e); // data wasn't successfully saved due to
        // a Web Storage API error
      }

      this.$meteor.call('user.setLocale', this.$i18n.locale, function (err) {
        if (err) {} else {}
      }); // set quasar's language too!!
      // import(`quasar/lang/${lang.value}`).then(language => {
      //     this.$q.lang.set(language.default)
      // })
    }
  },
  created: function created() {
    var _this5 = this;

    EventBus.$on('closeDrawer', function () {
      _this5.left_prev = _this5.left;
      _this5.left = false;
    });
    EventBus.$on('openDrawer', function () {
      _this5.left = _this5.left_prev;
    });
    var locale = this.$q.localStorage.getItem('locale');
    var aLang = this.langs.find(function (item) {
      return item.value === locale;
    }); // console.log('aLang', aLang)

    if (!aLang) {
      aLang = this.langs[0];
    }

    this.lang = aLang;
    /* console.log('WW2' + locale)
    if (locale) {
        console.log('0A')
        this.$i18n.locale = this.langs.find(item => item.value === locale)
    }
     console.log('this.$i18n.locale', this.$i18n.locale)
    let aLang = this.langs.find(item => item.value === this.$i18n.locale.value)
    console.log('aLang', aLang)
    if (!aLang) { aLang = this.langs[0] }
     this.lang = aLang */
  },
  mounted: function mounted() {
    EventBus.$emit('closeDrawer'); // console.log('MOUNTED0')
  }
};